import { render } from "./coming_soon.vue?vue&type=template&id=3fd15dad&scoped=true"
import script from "./coming_soon.vue?vue&type=script&lang=js"
export * from "./coming_soon.vue?vue&type=script&lang=js"

import "./coming_soon.vue?vue&type=style&index=0&id=3fd15dad&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fd15dad"]])

export default __exports__